export default class PopUpType {
  static readonly MESSAGE = new PopUpType('pop-up--message')
  static readonly ERROR = new PopUpType('pop-up--error')
  static readonly SUCCESS = new PopUpType('pop-up--success')
  static readonly WARNING = new PopUpType('pop-up--warning')

  private constructor(public readonly cssClass: string) {
  }
}
